module.exports = __webpack_public_path__ + "static/media/medium_literary_art.0fb7f6a9.jpg";